<template>
<div class="slide slide03">
    <h3 class="title">
        <div class="mo">유통사 퍼포먼스 캠페인</div>
        Strategy &amp; Result
    </h3>
    <span class="text">
        광고 반응율 및 구매 관련 KPI를 달성하기 위해 브랜드에 대한 고객의 구매 니즈 분석 <br>
        분석된 결과를 바탕으로 Creative 전략 개발로 효율 증대
    </span>
    <div class="graphWrap">
        <div class="graph g1">
            <span>구매효율을 높이기 위한 방향성</span>
            <ul class="list">
                <li class="no1">광고미디어 <br>효율성 증대</li>
                <li class="no2">Creative <br>효율성 증대</li>
                <li class="no3">브랜드 적합 <br>광고미디어 개발</li>
            </ul>
        </div>
        <div class="graph g2">
            <img src="@/assets/images/graphImg03.png" alt="구매 관련 CPA 지표">
        </div>
    </div>

    <div class="btnsWrap">
		<a herf="javascript:;" @click="fnSlickNext" class="slideNextBtn" v-if="!$device.windows">다음 페이지</a>
	</div>
</div>
</template>
<script>
export default {
    methods:{
		fnPopClose(){
			this.$emit('popClose' , event)
		},
		fnSlickNext(){
			this.$emit('slick_next' , event)
		}
	}
}
</script>